import { useNavigate } from "react-router-dom"
import { useDemoRole } from "./DemoAuthProvider"

const DemoRoleBadge = () => {
  const navigate = useNavigate()
  const demoRole = useDemoRole()

  if (!demoRole?.roleLabel) return null

  return (
    <button
      type="button"
      onClick={() => navigate("/demo/role-select")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 12px",
        borderRadius: "16px",
        border: "1px solid var(--brand-green, #16a34a)",
        backgroundColor: "transparent",
        color: "var(--brand-green, #16a34a)",
        fontSize: "12px",
        fontWeight: "600",
        cursor: "pointer",
        marginRight: "12px",
        whiteSpace: "nowrap",
      }}
      title="Switch demo role"
    >
      {demoRole.roleLabel} ▾
    </button>
  )
}

export default DemoRoleBadge
